export default {"src":"/_next/static/media/data-inventory.a4e679ba.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};